import { combineReducers } from '@ngrx/store';
import * as fromLocationSpecifications from './location-specification.reducer';
import * as fromJobsite from './jobsite-reducer/jobsite.reducer';
import * as fromProducts from './products-reducer/products.reducer';
import * as fromContactPerson from './contact-person.reducer';
import * as fromContactPersonRoles from './contact-person-roles.reducer';
import * as fromReceivingPersons from './receiving-persons.reducer';
import * as fromContracts from './contracts.reducer';
import * as fromAdditionalServices from './additional-services.reducer';
import * as fromUnits from './unit-reducer/units.reducer';
import * as fromNextWorkingDay from './next-working-day.reducer';
import * as fromDisabledDates from './load-holidays.reducer';
import * as fromPlants from './plants.reducer';
import * as fromAsyncValidations from './async-validations.reducer';
import * as fromPointOfDelivery from './point-of-delivery-reducer/point-of-delivery.reducer';
import * as fromTimeWindows from './../reducers/time-windows.reducer';

/* import { State } from '@cemex/cmx-client-layout';
import { InjectionToken } from '@angular/core'; */

export const locationSpecificationKey = 'location-specification';

export interface LocationSpecificationState {
  jobsite: fromJobsite.IJobsiteState;
  pointOfDelivery: fromPointOfDelivery.IPODState;
  locationSpecificationFormState: fromLocationSpecifications.LocationSpecificationFormState;
  products: fromProducts.IProductsState;
  contracts: fromContracts.State;
  units: fromUnits.State;
  plants: fromPlants.State;
  contactPerson: fromContactPerson.State;
  contactPersonRoles: fromContactPersonRoles.State;
  receivingPersons: fromReceivingPersons.State;
  nextWorkingDay: fromNextWorkingDay.NextWorkingDayState;
  disabledDates: fromDisabledDates.HolidaysState;
  additionalServices: fromAdditionalServices.State;
  asyncValidations: fromAsyncValidations.State;
  deliveryTimeWindows: fromTimeWindows.TimeWindowsState;
}

/* export interface LocationSpecificationState extends State {
  locationSpecificationState: LocationSpecificationFeatureState;
} */

export const reducers = combineReducers({
  jobsite: fromJobsite.jobsiteReducer,
  pointOfDelivery: fromPointOfDelivery.PODReducer,
  locationSpecificationFormState: fromLocationSpecifications.locationSpecificationFormReducer,
  products: fromProducts.productsReducer,
  contracts: fromContracts.reducer,
  units: fromUnits.reducer,
  plants: fromPlants.reducer,
  contactPerson: fromContactPerson.reducer,
  contactPersonRoles: fromContactPersonRoles.reducer,
  receivingPersons: fromReceivingPersons.reducer,
  nextWorkingDay: fromNextWorkingDay.reducer,
  disabledDates: fromDisabledDates.reducer,
  additionalServices: fromAdditionalServices.reducer,
  asyncValidations: fromAsyncValidations.reducer,
  deliveryTimeWindows: fromTimeWindows.timeWindowsReducer,
});
